export const featuresMap = {
    newColorsBranding: 'newColorsBranding',
};
//# sourceMappingURL=constants.js.map